module.exports = __webpack_public_path__ + "img/mobiles-footer-2x.8bc2433.webp";